import { useEffect, useState } from "react";

const navItems = [
  { id: "genres", label: "题材导览" },
  { id: "subtitle", label: "中字指南" },
  { id: "collection", label: "精选片单" },
  { id: "timeline", label: "经典年表" },
  { id: "mood", label: "按心情选" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span
            className={`w-8 h-8 rounded-md flex items-center justify-center ${
              scrolled || open ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-film-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-base md:text-lg font-semibold tracking-wide ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            欧美伦理电影
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100/90 hover:text-background-50 hover:bg-background-50/15"
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#collection"
            className="ml-2 px-4 py-2 rounded-md text-sm font-label whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            进入片单
          </a>
        </nav>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
            scrolled || open ? "text-foreground-900 hover:bg-background-200" : "text-background-50 hover:bg-background-50/20"
          }`}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <nav className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3 flex flex-col gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}